import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  registerReincorporation: ['data'],
  // Reducer
  registerReincorporationClear: null,
  registerReincorporationRequest: null,
  registerReincorporationSuccess: null,
  registerReincorporationFailure: ['error']
});

export { Creators, Types };

// 'procedureId',
// 'newPeriod',
// 'requiresPayment',
// 'campusId',
// 'careerId',
// 'modalityId',
// 'newCampusId',
// 'newCampusDescription',
// 'newCareerId',
// 'newCareerDescription',
// 'newModalityId',
// 'newModalityDescription',
// 'reincorporationType',
// 'academicPlan'
